<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Filtro de Período e Cards de Métricas Essenciais -->
    <div class="row mb-2">
      <div class="col-md-3 offset-md-9">
        <b-form-group label="Período:" label-for="periodSelect" label-cols="4" label-align="right" class="mb-0">
          <b-form-select
            id="periodSelect"
            v-model="period"
            :options="periodOptions"
            @change="onPeriodChange"
            class="w-100"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">
                  <i class="bx bx-user-check me-2 text-success"></i>
                  Pacientes no Período
                </p>
                <h4 class="mb-0">{{ metrics.patients_period || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                  <span class="avatar-title">
                    <i class="ri-user-add-line font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">
                  <i class="bx bx-file me-2 text-info"></i>
                  Exames no Período
                </p>
                <h4 class="mb-0">{{ metrics.exams_period || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                  <span class="avatar-title">
                    <i class="ri-file-list-2-line font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Exames Realizados e Ações Rápidas -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="card-title">Exames Realizados</h4>
              <button class="btn btn-success btn-sm" @click="loadExams">
                <i class="ri-refresh-line me-1"></i> Sincronizar Estudos
              </button>
            </div>
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Paciente</th>
                    <th>CPF</th>
                    <th>Data do Estudo</th>
                    <th>Modalidade</th>
                    <th>Descrição</th>
                    <th>Séries</th>
                    <th>Imagens</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="exam in exams" :key="exam.study_uid">
                    <td>{{ exam.patient_name || 'N/A' }}</td>
                    <td>{{ exam.patient_id || 'N/A' }}</td>
                    <td>{{ formatDate(exam.study_date) }}</td>
                    <td><span class="badge bg-soft-primary text-primary">{{ exam.modality || 'N/A' }}</span></td>
                    <td>{{ exam.study_description || 'N/A' }}</td>
                    <td><span class="badge bg-soft-info text-info">{{ exam.series_count || 0 }} séries</span></td>
                    <td><span class="badge bg-soft-secondary text-secondary">{{ exam.instance_count || 0 }} imagens</span></td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary me-1" @click="openViewer(exam)" title="Visualizar">
                        <i class="mdi mdi-eye"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-info ml-2" @click="viewDetails(exam)" title="Detalhes">
                        <i class="mdi mdi-information"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!exams.length && !loading">
                    <td colspan="8" class="text-center text-muted">Nenhum exame encontrado</td>
                  </tr>
                </tbody>
              </table>
              <!-- Paginação -->
              <nav v-if="total > perPage" class="mt-3">
                <ul class="pagination justify-content-center">
                  <li class="page-item" :class="{ disabled: page === 1 }">
                    <button class="page-link" @click="changePage(page - 1)" :disabled="page === 1">Anterior</button>
                  </li>
                  <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: p === page }">
                    <button class="page-link" @click="changePage(p)">{{ p }}</button>
                  </li>
                  <li class="page-item" :class="{ disabled: page === totalPages }">
                    <button class="page-link" @click="changePage(page + 1)" :disabled="page === totalPages">Próximo</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>      
    </div>

    <!-- ...removido estatísticas, gráficos, alertas e manutenção... -->
  </Layout>
</template>

<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { dicomService } from "@/api/dicom.js";
import { technicianService } from "@/api/technician";


export default {
  page: {
    title: "Dashboard Técnico",
    meta: [{ name: "description", content: "Dashboard para técnicos do RadioConnect" }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard Técnico",
      items: [
        {
          text: "Técnicos",
          href: "/technician",
        },
        {
          text: "Dashboard",
          active: true,
        },
      ],
      metrics: {},
      period: '7d',
      periodOptions: [
        { value: '1d', text: 'Último dia' },
        { value: '7d', text: 'Últimos 7 dias' },
        { value: '30d', text: 'Últimos 30 dias' },
        { value: '90d', text: 'Últimos 90 dias' },
        { value: '365d', text: 'Último ano' },
        { value: 'all', text: 'Todo o período' },
      ],
      exams: [],
      loading: false,
      page: 1,
      perPage: 10,
      total: 0,
    };
  },
    async created() {
      await this.loadMetrics();
      await this.loadExams();
    },
  methods: {
    async loadMetrics() {
      try {
        // Busca métricas do endpoint /technician/metrics?period=period
        const response = await technicianService.getMetricsByPeriod(this.period);
        if (response && response.data) {
          this.metrics = response.data;
        } else {
          this.metrics = {};
        }
      } catch (error) {
        console.error('Erro ao buscar métricas:', error);
        this.metrics = {};
      }
    },

    onPeriodChange() {
      this.loadMetrics();
    },

    async loadExams() {
      this.loading = true;
      try {
        const offset = (this.page - 1) * this.perPage;
        const params = { offset, limit: this.perPage };
        const response = await dicomService.getOrthancStudies(params);
        if (response && response.data && response.data.studies && Array.isArray(response.data.studies)) {
          this.exams = response.data.studies;
          this.total = response.data.total || this.exams.length;
        } else {
          this.exams = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("Erro ao carregar exames:", error);
        this.$toast.error("Erro ao carregar exames realizados");
        this.exams = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPages || newPage === this.page) return;
      this.page = newPage;
      this.loadExams();
    },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) || 1;
    }
  },

    async openViewer(exam) {
      try {
        let ohifUrl = null;
        if (exam.viewer_links && exam.viewer_links.ohif_viewer) {
          ohifUrl = exam.viewer_links.ohif_viewer;
        } else if (exam.ohif_viewer_url) {
          ohifUrl = exam.ohif_viewer_url;
        } else {
          // Fallback: buscar via API se não tiver a URL
          const response = await dicomService.getViewerLink(exam.study_uid);
          if (response && response.data && response.data.viewer_links && response.data.viewer_links.ohif_viewer) {
            ohifUrl = response.data.viewer_links.ohif_viewer;
          }
        }
        if (ohifUrl) {
          const viewerUrl = this.addTokenToUrl ? this.addTokenToUrl(ohifUrl) : ohifUrl;
          window.open(viewerUrl, '_blank');
        } else {
          this.$toast.error('Não foi possível obter o link do visualizador');
        }
      } catch (error) {
        console.error('Erro ao abrir visualizador:', error);
        this.$toast.error('Erro ao abrir visualizador');
      }
    },

    // Copiado do viewer.vue para garantir token na URL se necessário
    addTokenToUrl(url) {
      if (!url || typeof url !== 'string') return url || '';
      try {
        let accessToken = null;
        if (this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.currentUser) {
          accessToken = this.$store.state.auth.currentUser.access_token;
        }
        if (!accessToken && this.$store && this.$store.state) {
          accessToken = this.$store.state.auth?.accessToken || 
                       this.$store.state.auth?.token ||
                       this.$store.state.token ||
                       this.$store.getters?.accessToken;
        }
        if (!accessToken) {
          accessToken = localStorage.getItem('token') || 
                       localStorage.getItem('access_token') ||
                       localStorage.getItem('authToken') ||
                       localStorage.getItem('jwt_token');
        }
        if (!accessToken) {
          accessToken = sessionStorage.getItem('token') || 
                       sessionStorage.getItem('access_token');
        }
        if (!accessToken) return url;
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}token=${accessToken}`;
      } catch (error) {
        return url || '';
      }
    },
    viewDetails(exam) {
      this.$router.push(`/dicom/study/${exam.study_uid}`);
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('pt-BR');
    }
  },
};
</script>

<style scoped>
.mini-stats-wid {
  overflow: hidden;
}

.equipment-status .badge {
  font-size: 10px;
}

.table th,
.table td {
  font-size: 14px;
}
</style>
